import { render, staticRenderFns } from "./SearchPatientModal.vue?vue&type=template&id=04b72bd8&scoped=true"
import script from "./SearchPatientModal.vue?vue&type=script&lang=js"
export * from "./SearchPatientModal.vue?vue&type=script&lang=js"
import style0 from "./SearchPatientModal.vue?vue&type=style&index=0&id=04b72bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b72bd8",
  null
  
)

export default component.exports